import { useState } from 'react';

// import { routeTypes } from '../../../useSystemRoutes'
// import { useSystemPrompt } from '../../../useSystemPrompt';

import { documentTypes } from "../../../api/useDocuments"
import { validateRouteType } from './default';

import {
    useDependencies,
    targetTypes as dependencyTargetTypes,
    dependencyModules,
    dependencyRelations,
    dependencyRefs,
    formikDependencyStateField,
} from "../../../api/useDependencies"

export function useStatePurchaseOrder() {

    // const { promptMessage } = useSystemPrompt()

    const { getDependencyItem } = useDependencies()

    // const validateRouteType = (val) => {
    //     if (val !== routeTypes.admin) throw new Error(`Unsupported route : ${val}`)
    // }

    const updateFormikStates = async ({
        data,
        routeType,
        setFieldValue,
    }) => {

        // validateRouteType(routeType);
        validateRouteType(routeType, documentTypes)

        const {
            document,
            items
        } = data

        // only load these fields
        setFieldValue(`remark`, document?.doc_remark ? document.doc_remark : "")

        items.forEach((e, index) => {
            setFieldValue(`rows.${index}.itemId`, e?.item_id)
            setFieldValue(`rows.${index}.name`, e?.item_name)
            setFieldValue(`rows.${index}.code`, e?.code)
            setFieldValue(`rows.${index}.description`, e?.description)
            setFieldValue(`rows.${index}.qty`, e?.qty)
            setFieldValue(`rows.${index}.uomId`, e?.uom_id)
            setFieldValue(`rows.${index}.uomName`, e?.uom_name)
            setFieldValue(`rows.${index}.price`, e?.uom_price)
        })


        setFieldValue(`userId`, document?.user_id)
        setFieldValue(`username`, document?.profile_name)

        let depStates = getDependencyItem({
            targetType: dependencyTargetTypes.document,
            dependencyModule: document?.type.toLowerCase(),
            dependencyRef: dependencyRefs.document,
            targetId: document?.id,
            relation: dependencyRelations.reference,
        })

        setFieldValue(formikDependencyStateField, [depStates]) // only need one dependency item

    }

    const getFormikDependencyStates = ({ values }) => {
        return {
            [`${formikDependencyStateField}`]: values[`${formikDependencyStateField}`]
        }
    }

    return {
        updateFormikStates,
        getFormikDependencyStates

    }

}